import { CircularProgress, CircularProgressLabel, Flex, Text } from '@chakra-ui/react'
import { ElementoTooltipCmp } from '../../../../../components/ElementoTooltipCmp'
import { ObterCorPercentual } from '../../../../../Utils/Helper'
import { iIndicador } from '../../../gestao'
import { AvataresParticipantes } from '../AvataresParticipantes'

interface iCardIndicadorProps {
  indicador: iIndicador
  pctPrincipal: number
  legendaPrincipal: string
  acumuladoLabel: string
  previstoLabel: string
  metaLabel: string
  onClick?: () => void
}

export const CardIndicador: React.FC<iCardIndicadorProps> = ({ indicador, pctPrincipal, legendaPrincipal, acumuladoLabel, previstoLabel, metaLabel, onClick }) => {
  const indisponivel = acumuladoLabel === 'N/A'
  const cor = ObterCorPercentual(pctPrincipal, indisponivel)

  return (
    <Flex
      flexDir={'column'}
      bg={'var(--c1)'}
      border={'1px solid var(--c5)'}
      borderRadius={'.5rem'}
      padding={'1rem'}
      gap={'.75rem'}
      boxShadow={'var(--SombraBackground)'}
      h={'100%'}
      onClick={onClick}
      cursor={onClick ? 'pointer' : 'default'}
      transition={'transform .15s, border-color .15s'}
      _hover={onClick ? { transform: 'translateY(-2px)', borderColor: 'var(--Azul)' } : undefined}
    >
      <ElementoTooltipCmp label={indicador.nome}>
        <Text fontWeight={'700'} fontSize={'.875rem'} noOfLines={2} color={'var(--Gray1)'} minH={'2.4rem'}>
          {indicador.nome}
        </Text>
      </ElementoTooltipCmp>

      <Flex alignItems={'center'} gap={'1rem'}>
        <Flex flexDir={'column'} alignItems={'center'} flexShrink={0}>
          <CircularProgress
            value={indisponivel ? 100 : Math.min(100, pctPrincipal)}
            color={cor}
            size={'4.5rem'}
            thickness={'.7rem'}
            trackColor={'var(--c4)'}
          >
            <CircularProgressLabel fontWeight={'700'} fontSize={'.8rem'} color={indisponivel ? 'var(--Gray3)' : undefined}>
              {indisponivel ? 'N/A' : `${pctPrincipal.toFixed(0)}%`}
            </CircularProgressLabel>
          </CircularProgress>
          <Text fontSize={'.62rem'} color={'var(--Gray3)'} textAlign={'center'} mt={'.25rem'} maxW={'5.5rem'}>
            {legendaPrincipal}
          </Text>
        </Flex>

        <Flex flexDir={'column'} fontSize={'.78rem'} gap={'.1rem'}>
          <Text color={'var(--Gray3)'}>Acumulado</Text>
          <Text fontWeight={'600'} color={'var(--Gray1)'}>{acumuladoLabel}</Text>
          <Text color={'var(--Gray3)'} mt={'.2rem'}>Previsto</Text>
          <Text fontWeight={'600'} color={'var(--Gray1)'}>{previstoLabel}</Text>
          <Text color={'var(--Gray3)'} mt={'.2rem'}>Meta</Text>
          <Text fontWeight={'600'} color={'var(--Gray1)'}>{metaLabel}</Text>
        </Flex>
      </Flex>

      {(indicador.responsavel != null || (indicador.participantes != null && indicador.participantes.length > 0)) && (
        <Flex mt={'auto'} pt={'.25rem'}>
          <AvataresParticipantes responsavel={indicador.responsavel} participantes={indicador.participantes} />
        </Flex>
      )}
    </Flex>
  )
}
